/**
 * @name dataSize
 * @function
 * @description Converts bytes to an order of magnitude
 */
export const dataSize = ( bytes = 0, decimals = 2 ) => {

    const k = 1024,
    dm = decimals < 0 ? 0 : decimals,
    sizes = [ 'b', 'Kb', 'Mb', 'Gb' ],
    i = Math.floor( Math.log( bytes ) / Math.log( k ) )

    if( !bytes ) return `0${ sizes[ 0 ]}`;

    return `${ parseFloat( ( bytes / Math.pow( k, i ) ).toFixed( dm ) )}${ sizes[ i ] }`

};